<div class="pickup-things" *ngIf="title || displayItems.length > 0">
  <h5 class="pickup-things--title" *ngIf="title">{{ title }}</h5>
  
  <div class="pickup-things--container">
    <div 
      *ngFor="let item of displayItems" 
      class="pickup-things--item"
    >
      <div 
        class="pickup-things--card"
        [style.background-color]="item.backgroundColor || '#ffffff'"
      >
        <div 
          class="pickup-things--icon" 
          *ngIf="item.icon || item.iconSrc"
          [style.background-color]="item.iconColor || '#f5f5f5'"
        >
          <!-- Use img tag if iconSrc is provided -->
          <img *ngIf="item.iconSrc" [src]="item.iconSrc" [alt]="item.title" />
          
          <!-- Use inline SVG if icon string is provided -->
          <svg *ngIf="!item.iconSrc && item.icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <g [innerHTML]="getSafeIcon(item.icon)"></g>
          </svg>
        </div>
        
        <div class="pickup-things--content-wrapper">
          <div class="pickup-things--content">
            <h3 class="pickup-things--item-title" [title]="item.title">{{ item.title }}</h3>
            <p class="pickup-things--item-description" *ngIf="item.description" [title]="item.description">{{ item.description }}</p>
          </div>
        </div>
        
        <a 
          *ngIf="item.actionLink"
          [href]="item.actionLink"
          class="pickup-things--action-icon"
          [attr.aria-label]="'Navigate to ' + item.title"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <path d="M12 8L16 12L12 16M16 12H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>
    </div>
  </div>
</div>

